import React, { useState, useRef, useEffect } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import "../../styles/common/VideoCard.scss";
import ViewMaterialPopup from "./ViewMaterialPopup";

const VideoCard = ({
  video,
  onEdit,
  onDelete,
  onPlay,
  hideActionBtn = false,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const { title, thumbnail_url, video_url, description, source_type } = video;

  const handleMenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu((prev) => !prev);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    onEdit && onEdit(video);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowMenu(false);
    onDelete && onDelete(video);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  return (
    <div className="video-card">
      <div className="thumbnail-wrapper" onClick={onPlay}>
        {thumbnail_url ? (
          <img src={thumbnail_url} alt={title} className="video-thumbnail" />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <VideoLibraryIcon style={{ fontSize: 40, color: "#ffffff" }} />
          </div>
        )}
        <div className="play-icon">▶</div>

        {!hideActionBtn && (
          <div
            className="video-actions"
            ref={menuRef}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="action-btn"
              onClick={handleMenuToggle}
              type="button"
            >
              <MoreVertIcon fontSize="small" />
            </button>

            {showMenu && (
              <div className="video-actions-menu">
                <button className="actions-item" onClick={handleEdit}>
                  <EditIcon fontSize="small" /> Edit
                </button>
                <button className="actions-item danger" onClick={handleDelete}>
                  <DeleteIcon fontSize="small" /> Delete
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="video-info">
        <h3 className="video-title" title={title}>
          {title}
        </h3>
        {description && <p className="video-description">{description}</p>}
      </div>
    </div>
  );
};

export default VideoCard;
